module.exports = __webpack_public_path__ + "img/organizational_level.1a52637c.svg";